<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap1">1</h1>
<p class="noind" style="margin-top:30px;">“T<span class="small">ELL ME WHY</span> I shouldn’t smash your face.”</p>
<p class="ind">Bart Richter could hardly get the words out. His teeth were clenched, like a mousetrap that had snapped just short of its prey.</p>
<p class="ind">Sam Hughes felt like the mouse.</p>
<p class="ind"><i>Run.</i></p>
<p class="ind"><i>He’s crazy.</i></p>
<p class="ind">Sam knew he should have given Bart the computer class homework — just handed him a copied disk, no tricks. He should have let Bart cheat, same as always. Maybe change a line here and there so it wouldn’t be too obvious.</p>
<p class="ind">Planting the virus was stupid.</p>
<p class="ind"><i>What was I thinking?</i> Sam asked himself.</p>
<p class="ind">The plan seemed foolproof at the time. It wasn’t a <i>killer</i> virus. It was easy to fix. Bart would insert the disk into his computer. His files would disappear. He’d call Sam in desperation. Sam would rush over, suddenly the hero. He’d agree to retrieve the files — but only if Bart agreed to stop the cheating.</p>
<p class="ind">But foolproof was not the same as Bart-proof.</p>
<p class="ind">Bart had never opened the disk. Instead, he had just handed it in.</p>
<p class="ind">The first person to open it had been Mr. Antonelli, the computer teacher.</p>
<p class="ind">And <i>his</i> files had been wiped out.</p>
<p class="ind">His class notes, his family finances, his e-mail, and the first seven chapters of his Great American Novel — all were gone in an instant.</p>
<p class="ind">By the end of the day, Bart was gone, too. From school, that is. Suspended. But only after Mr. Antonelli had yelled at him, flunked him, and threatened to sue him.</p>
<p class="ind">Which was why Sam was in the back of the Blue Mountain Mall on Friday evening, facing doom in the form of a fourteen-year-old halfback bent on vengeance.</p>
<p class="ind">“Mr. Antonelli’s a smart guy,” Sam said, backpedaling. “It’s an easy virus. He — he can undelete those files, no sweat. I can tell him how, if you — ”</p>
<p class="ind">Sam’s back made contact with the brick wall. He looked to his right, toward the mall entrance, but a Dumpster blocked it from view.</p>
<p class="ind">Bart kept approaching. “I don’t get it. What idiot would put a <i>virus</i> on his own homework?”</p>
<p class="ind">“It wasn’t on <i>my</i> disk.”</p>
<p class="ind"><i>No.</i></p>
<p class="ind"><i>Sam, you fool.</i></p>
<p class="ind">The realization slowly spread across Bart’s face. “You did it to me on purpose — ?”</p>
<p class="ind">“I didn’t think you’d hand it in — ”</p>
<p class="ind">Bart swung. Fast.</p>
<p class="ind">Sam ducked, but he wasn’t quick enough.</p>
<p class="ind">He was jolted off the ground, following the trajectory of his flying jaw. With a resounding CLANG, he slammed against the side of the Dumpster.</p>
<p class="ind">“Use your brain NOW, smart guy,” Bart growled.</p>
<p class="ind">He reared his arm back again.</p>
<p class="ind">Sam gripped the lip of the Dumpster and pulled himself up. The smell of rotting food wafted up from inside.</p>
<p class="ind">He felt Bart’s hand close around his calf.</p>
<p class="ind">“BART!”</p>
<p class="ind">Jamie Richter’s voice.</p>
<p class="ind">Bart’s twin sister. The lead singer in the worst garage band Sam had ever heard, Inhuman Phenomena. “The voice of a dying tomcat on a rainy night,” he had said in his school newspaper review.</p>
<p class="ind">Maybe he’d been too harsh.</p>
<p class="ind"><i>You’ve sabotaged one Richter. Insulted the other.</i></p>
<p class="ind"><i>Great, Sam.</i></p>
<p class="ind"><i>No way out of this one.</i></p>
<p class="ind">“Hulllk— ”A cry for help choked in Sam’s throat. He coughed out a glob of saliva.</p>
<p class="ind">Bart’s grip loosened. “What the — ?”</p>
<p class="ind">Bart was stumbling backward. Wiping goo from his face. Sam’s goo.</p>
<p class="ind"><i>Dead.</i></p>
<p class="ind"><i>You are dead.</i></p>
<p class="ind">“BART, YOU FATHEAD!”</p>
<p class="ind">Jamie’s footsteps rang out. Coming closer.</p>
<p class="ind">Bart turned. “WHAT?” he snapped.</p>
<p class="ind"><i>NOW.</i></p>
<p class="ind">Sam jumped back onto the blacktop. The impact sent a stab of pain through his already swelling jaw.</p>
<p class="ind">Bart spun around and lunged for him.</p>
<p class="ind">But Sam was gone. Running across the lot.</p>
<p class="ind">“Sam?” Jamie called out.</p>
<p class="ind">Sam darted out onto the sidewalk.</p>
<p class="ind">“SAM, I HAVE TO TALK TO YOU!”</p>
<p class="ind">Now they were both chasing him.</p>
<p class="ind">He ran down the hill. Toward Rio de Ratas, “River of Rats,” the brownish waterway that bordered town. The river had a real name, but no one remembered it. Pollution from Blue Mountain’s factories had ruined the water ages ago. Nowadays the factories stood empty and abandoned, but the look and stench of the river remained.</p>
<p class="ind">Just before the river was a cyclone fence. Sam squeezed through a hole, under a lopsided, sun-bleached sign that bore the faint words <span class="small">BLUE MOUNTAIN INDUSTRIAL PARK</span>.</p>
<p class="ind">The setting sun made black holes of the alleyways that snaked between the old brick buildings. Sam’s footsteps tapped flatly against the cracked blacktop. Wary eyes glared at him as he passed makeshift shelters of old planks and cardboard boxes piled against the walls at the edges of the street-lamp light.</p>
<p class="ind"><i>Where is it?</i></p>
<p class="ind">He hadn’t been to the Turing-Douglas Research Labs in a long time. Not since he was a kid. But it would be a perfect hiding place.</p>
<p class="ind"><i>Down Front Street, then right on Second.</i></p>
<p class="ind">The memories bubbled up through his panic. Coming to this neighborhood with his parents when he was a kid, night after night. The dank, stuffy labs where Mom and Dad told him to do his homework while they worked. The electronic equipment that loomed over him, beeping and burbling while he tried to concentrate but never could, because of that feeling, that weird feeling —</p>
<p class="ind"><i>There.</i></p>
<p class="ind">As he rounded a corner he spotted the familiar rotting truck dock. The grimy, graffiti-covered tan-brick walls.</p>
<p class="ind">The windows of the building were dark. Maybe his mom and dad had already gone.</p>
<p class="ind"><i>Just my luck.</i></p>
<p class="ind">On a normal night, they were there until midnight. Lately they’d been working on another “special government project.” Sam was beginning to think there weren’t really any government projects. It was an excuse to get away from him. They just liked being scientists more than being parents.</p>
<p class="ind"><i>Where are they when I need them?</i></p>
<p class="ind">The front door was locked. Sam raced around to the east side of the building. In the deepening darkness, he ducked into a basement stairwell.</p>
<p class="ind">Something rustled from below. A small shadow scampered out of the stairwell and into the night.</p>
<p class="ind">Sam jumped, stifling a scream. His head banged against a cement overhang.</p>
<p class="ind">For a moment, everything went black. Sam crumpled to the ground.</p>
<p class="ind">Then he picked himself up, staggering slowly down the steps.</p>
<p class="ind">At the bottom, near a grime-caked basement window, he crouched and waited.</p>
<p class="ind">“HUGHES! I’M GOING TO GET YOU!”</p>
<p class="ind">Bart.</p>
<p class="ind">Near. Maybe thirty yards away.</p>
<p class="ind">The footsteps grew louder. They began circling the building, then suddenly stopped.</p>
<p class="ind">“AAAAAGH!” Jamie shrieked. “Rats!”</p>
<p class="ind"><i>Stay put.</i></p>
<p class="ind"><i>Just stay put.</i></p>
<p class="ind">“They’re just <i>animals</i>.” Bart’s voice was calm, mocking.</p>
<p class="ind">But Jamie was already booking.</p>
<p class="ind">A moment later, so was Bart the Brave.</p>
<p class="ind">Their footsteps retreated into silence. Now the only sounds were the rustling leaves and Sam’s dry, raspy breaths.</p>
<p class="ind">Safe.</p>
<p class="ind">For now, at least.</p>
<p class="ind">He felt his swollen jaw. It ached badly. He was bleeding a little.</p>
<p class="ind">Sam stood, bracing himself against the sides of the stairwell.</p>
<p class="ind">The bump was worse than he’d thought.</p>
<p class="ind">His head felt strange. As if it were expanding. As if he had to hold on to it, just to keep it intact.</p>
<p class="ind">And he remembered.</p>
<p class="ind"><i>“Mom, can we go-o-o-o?”</i></p>
<p class="ind"><i>“Have you finished your homework, dear?”</i></p>
<p class="ind"><i>“I have a headache!”</i></p>
<p class="ind"><i>“Now, Sam, why does it seem you always have a headache when you have to do homework?”</i></p>
<p class="ind">He’d had headaches a lot when he was a child. Bad ones. Just like this one — as if his head were about to explode.</p>
<p class="ind"><i>It’s this place. It brings out the worst in me.</i></p>
<p class="ind">As Sam climbed the stairs, a sudden throb pushed against the inside of his skull.</p>
<p class="ind">His knees buckled. He clutched the rusted banister.</p>
<p class="ind"><i>Do. Not. Make. Noise.</i></p>
<p class="ind"><i>Just go.</i></p>
<p class="ind">This was a bad one. A migraine, maybe. He must have really smacked the overhang hard.</p>
<p class="ind">Grimacing, he took another step.</p>
<p class="ind">The darkness gave way to a volcano of white, green, and red. As if the world had ignited.</p>
<p class="ind">He knew he wouldn’t make it home. Not by himself.</p>
<p class="ind">Not even to the top of the stairs.</p>
<p class="ind"><i>Help me.</i></p>
<p class="ind"><i>HELP ME!</i></p>
<p class="ind">“Help me …”</p>
<p class="ind">Sam jumped.</p>
<p class="ind">For a moment the pain retracted.</p>
<p class="ind">The voice had come from below him.</p>
<p class="ind">From behind the basement window.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5chap1.vue?c949674c